// NPM Imports
import React, { Component } from "react";
// import { Link } from "react-router-dom";
import { connect } from "react-redux";

// import { Button } from "../../../revvComponents";
import { IMAGE_URLS } from "../../../constants";

// action imports
import showNavbar from "../../../actions/NavbarWrapperAction";
import RevvLogo from "../../RecipientDocHeader/RevvLogo";

const { LZ_ERROR_IMAGE: errorImage } = IMAGE_URLS;

class DocumentErrorRecipient404 extends Component {
  state = {};

  componentDidMount() {
    this.props.showNavbar(true);
  }

  componentWillUnmount() {
    this.props.showNavbar(false);
  }

  _navigateToEsignature = () => {
    // navigation link need to be changed here
    let url = `${process.env.REACT_APP_DOMAIN_NAME}`;
    if (process.env.REACT_APP_LOGO_REDIRECTION_URL) {
      url = `${process.env.REACT_APP_LOGO_REDIRECTION_URL}my/esignature`;
      window.location.href = url;
    } else {
      window.location.href = `${process.env.REACT_APP_DOMAIN_NAME}`;
    }
  };

  render() {
    return (
      <div className="document-error-recipient-404-wrapper">
        <div className="document-error-recipient-404-header">
          <RevvLogo />
        </div>
        <div className="document-error-recipient-404">
          <img src={errorImage} alt="" />
          <div className="document-error-recipient-404-body">
            <span className="document-error-recipient-404-title">
              Uh oh! We couldn&apos;t find the document you&apos;re looking for.
            </span>
            <span className="document-error-recipient-404-msg">
              This happens when the owner has deleted the document or may not
              have given you permission to access it.
            </span>

            {/* <span>
              {this.props.isLz || this.props.isError ? (
                <Button
                  type="five"
                  data-test="navigate-to-esignature-btn"
                  className="navigate-to-esignature-btn"
                  onClick={() => this._navigateToEsignature()}>
                  Go to eSignature page
                </Button>
              ) : (
                <Link to="/assets">Go to your Documents</Link>
              )}
            </span> */}

            {/* <span className="document-error-recipient-404-tip">
            <span aria-label="bulb" role="img">
              &#128161;
            </span>{" "}
            Tip: If you have multiple Revv accounts, ensure that you&apos;re
            logged into the right one to view the document.
          </span> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { is_lz: isLz } = state.RevvSignStore;
  return {
    isLz,
  };
};

const mapDispatchToProps = { showNavbar };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentErrorRecipient404);
